import Spring from "@components/Spring";
import AuthenticatedImage from "@components/AuthenticatedImage";
import Score from "@ui/Score";
import PostponeController from "network/PostponeController";
import PropTypes from "prop-types";
import React, { useState } from "react";
import MatchController from '../../network/MatchController';
import styles from "./styles.module.scss";

const MatchCard = ({ match, cancelCount, postponeCount, id, isCancelWindowOpen, index, variant = "basic" }) => {
  const homeTeam = match?.home_blanket || {};
  const awayTeam = match?.away_blanket || {};
  const matchController = new MatchController();
  const postponeController = new PostponeController();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showPostponeModal, setShowPostponeModal] = useState(false);
  const isHome = match?.home_team?.id === id;
  const currentTeam = isHome ? homeTeam : awayTeam;

  const formatDate = (dateString) => {
    if (!dateString) return "Nicht Zugeornet";
    const datePart = dateString.split("T")[0];
    const timePart = dateString.split("T")[1].replace("Z", "");

    const [year, month, day] = datePart.split("-");
    const [hour, minute] = timePart.split(":");

    return `${day}.${month}.${year} ${hour}:${minute}`;
  };

  const goToBlankett = () => {
    if (match.id) {
      window.location.href = `/kader/matches/${match.id}`;
    } else {
      console.error("Unable to confirm, player or team is missing.");
    }
  };

  const requester = () => ({
    id: id,
    sid: currentTeam.sid || "",
    logo: currentTeam.logo || "",
    teamName: currentTeam.name || ""
  });

  const requestee = () => {
    const opponentTeam = isHome ? awayTeam : homeTeam;
    return {
      id: isHome ? match.away_team?.id || "" : match.home_team?.id || "",
      sid: opponentTeam.sid || "",
      logo: opponentTeam.logo || "",
      teamName: opponentTeam.name || ""
    };
  };

  const cancelGame = async () => {
    const homeTeamId = match?.home_team?.id;
    const awayTeamId = match?.away_team?.id;
    const teamSide = id === homeTeamId ? "away" : id === awayTeamId ? "home" : null;

    if (!teamSide) {
      console.error("Invalid team ID provided.");
      return;
    }

    try {
      await matchController.teamCancel(match.id, teamSide);
      console.log("Match successfully marked as no-show.");
      window.location.reload(); // 🔄 Refresh the page
    } catch (error) {
      console.error("Failed to cancel the game:", error);
    }
  };

  const matchStatus = (matchData) => {
    if (!matchData) return;
    const { status } = matchData;
    switch (status) {
      case "pending":
        return "Spielvorschau";
      case "cancelled":
        return "Spiel Abgesagt";
      case "completed":
        return "Spiel Abgeschlossen";
      default:
        return "Spiel Nicht Bearbeitbar";
    }
  };

  const matchButtonTxt = (matchData) => {
    if (!matchData) return;
    const { status } = matchData;
    if (status === "pending") {
      return "Blankett Ausfüllen";
    }
    return "Blankett Gesperrt";
  };

  return (
    <Spring className={`${styles.container}`} type="slideUp" index={index}>
      <div
        className={"card-padded d-flex flex-column g-20"}
        style={{
          paddingBottom: variant !== "extended" ? "var(--card-padding)" : 10,
          cursor: "pointer",
        }}
      >
        <div className="d-flex align-items-center justify-content-between p-relative">
          <img
            className={styles.clublogo}
            src={homeTeam.logo || ""}
            alt={homeTeam.name || "Home Team"}
          />
          <Score
            team1={match.score.home || 0}
            team2={match.score.away || 0}
            variant="alt"
          />
          <img
            className={styles.clublogo}
            src={awayTeam.logo || ""}
            alt={awayTeam.name || "Away Team"}
          />
        </div>

        <div className="d-flex justify-content-between g-30">
          <div style={{ minWidth: 0, maxWidth: "100px" }}>
            <h5>{homeTeam.name || "Home Team"}</h5>
          </div>

          <div style={{ width: "130px" }}>
            <h4
              style={{ color: "orange", textAlign: "center" }}
              className="text-12 text-overflow"
            >
              Status:
            </h4>
            <h2
              style={{ textAlign: "center", maxWidth: "150px", height: "auto" }}
              className="text-12 text-overflow"
            >
              {matchStatus(match) || "Nicht Zugeornet"}
            </h2>
          </div>

          <div
            className="text-right"
            style={{ minWidth: 0, width: "100px", textAlign: "right" }}
          >
            <h5>{awayTeam.name || "Away Team"}</h5>
          </div>
        </div>

        <div className="d-flex justify-content-between g-30 row">
          <AuthenticatedImage
            className={styles.dress}
            src={currentTeam.dress || ""}
            alt={currentTeam.name || (isHome ? "Home Team" : "Away Team")}
          />

          {match.details.date && (
            <div className="d-flex flex-column justify-content-center g-5">
              <h5
                style={{ color: "orange", textAlign: "center" }}
                className="text-12 text-overflow"
              >
                Sportplatz:
              </h5>

              <h2
                style={{
                  textAlign: "center",
                  maxWidth: "150px",
                  height: "auto",
                  color: "white",
                }}
                className="text-10"
              >
                {match.details.location || "Nicht Zugeornet"}, {formatDate(match.details.date) || "Nicht Zugeornet"}
              </h2>
            </div>
          )}

          <div style={{ minWidthwidth: "80px" }}></div>
        </div>

        {match.status === "pending" && (
            <div className={styles.btnContainer}>
                <button className={styles.btnOrange} onClick={goToBlankett}>
                {matchButtonTxt(match)}
                </button>

                {isCancelWindowOpen && (
                <>
                    <button
                    className={styles.postponeBtn}
                    onClick={() => setShowPostponeModal(true)}
                    disabled={postponeCount >= 2}
                    >
                    Spiel Verschieben
                    </button>

                    <button
                    className={styles.cancelBtn}
                    onClick={() => setShowCancelModal(true)}
                    disabled={cancelCount >= 3}
                    >
                    Spiel Absagen
                    </button>
                </>
                )}
            </div>
            )}
      </div>

      {variant === "extended" && (
        <div className="border-top">
          {/* Add additional extended view details if required */}
        </div>
      )}

      {showCancelModal && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modal}>
            <h3 className={styles.modaltext}>Sind Sie sicher, dass Sie das Spiel absagen wollen?</h3>
            <p>
            {(() => {
                const currentCancel = cancelCount ?? 0;
                switch (currentCancel) {
                case 0:
                    return "Das wäre Ihre 1. Absage in dieser Saison. Diese Absage kostet 170€. Und wird Ihnen direkt von Ihrem Guthaben verrechnet.";
                case 1:
                    return "Das wäre Ihre 2. Absage in dieser Saison. Diese Absage kostet 270€. Und wird Ihnen direkt von Ihrem Guthaben verrechnet.";
                case 2:
                    return "Das ist Ihre letzte Möglichkeit, ein Spiel abzusagen. Diese Absage kostet 370€. Und wird Ihnen direkt von Ihrem Guthaben verrechnet.";
                default:
                    return "Sie haben bereits 3 Absagen diese Saison. Eine weitere Absage ist nicht erlaubt.";
                }
            })()}
            </p>
            <div className={styles.modalActions}>
              <button onClick={() => setShowCancelModal(false)}>Abbrechen</button>
              <button
                className={styles.btnOrange}
                onClick={async () => {
                  await cancelGame();
                  setShowCancelModal(false);
                }}
              >
                Spiel Absagen
              </button>
            </div>
          </div>
        </div>
      )}

      {showPostponeModal && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modal}>
          <p style={{ marginBottom: "10px", color: "orange", fontWeight: "bold"}}>
            {(() => {
                const currentCancel = cancelCount ?? 0;
                switch (currentCancel) {
                case 0:
                    return "Das wäre Ihre 1. Spielverlegung in dieser Saison.";
                case 1:
                    return "Das ist Ihre letzte Möglichkeit, ein Spiel zu verschieben.";
                default:
                    return "Sie haben bereits 2 Spielverlegungen diese Saison. Eine weitere Spielverlegung ist nicht erlaubt.";
                }
            })()}
            </p>
            <h3 className={styles.modaltext2}>Eine Spielverlegung ist nur mit Ihrem Einverständnis möglich. Mit Ihrer Bestätigung wird eine Anfrage an die gegnerische Mannschaft sowie an den ÖKFB-Administrator gesendet, um deren Zustimmung oder Ablehnung einzuholen.</h3>
            <div className={styles.modalActions}>
              <button onClick={() => setShowPostponeModal(false)}>Abbrechen</button>
              <button
                className={styles.btnOrange}
                onClick={async () => {
                    await postponeController.createNewRequest(match.id, requester(), requestee());
                    setShowPostponeModal(false);
                }}
              >
                Spiel Verschieben
              </button>
            </div>
          </div>
        </div>
      )}
    </Spring>
  );
};

MatchCard.propTypes = {
  match: PropTypes.object.isRequired,
  index: PropTypes.number,
  variant: PropTypes.oneOf(["basic", "extended"]),
};

export default MatchCard;
